// extracted by mini-css-extract-plugin
export default {"container":"AdminOrders_container__zRMMD","table":"AdminOrders_table__EKpaz","deleteButton":"AdminOrders_deleteButton__z4Ie8","error":"AdminOrders_error__MENUD"};